module.exports = __webpack_public_path__ + "img/man--768.fa92652.jpg";